import { useQuery } from '@tanstack/react-query';
import { fetchDashboardData } from '../services/dashboardDataService';

export const useDashboardData = (tenantId, options = {}) => {
  const { scope = `member:${tenantId || ''}`, enabled: enabledOption = true, ...queryOptions } = options;
  const enabled = Boolean(tenantId) && enabledOption;

  return useQuery({
    ...queryOptions,
    queryKey: ['dashboard', scope, tenantId],
    queryFn: () => fetchDashboardData(tenantId),
    enabled,
  });
};
